import { useEffect, useRef, useMemo } from 'react'
import { View, Text, Animated, StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import { hapticSuccess } from '../../lib/haptics'
import { colors, fonts, radius } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
export default function PickToast({ riders, leagueCount, onDone }) {
  const { t } = useTranslation()
  const tc = useThemeColors()
  const styles = useMemo(() => makeStyles(tc), [tc])

  const translateY = useRef(new Animated.Value(120)).current
  const opacity = useRef(new Animated.Value(0)).current
  const scale = useRef(new Animated.Value(0.9)).current
  const isMounted = useRef(true)
  const onDoneRef = useRef(onDone)

  // Tieni onDoneRef aggiornato senza rieseguire l'effect
  useEffect(() => { onDoneRef.current = onDone }, [onDone])

  useEffect(() => {
    isMounted.current = true

    // Haptic feedback di successo
    // Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success)

    hapticSuccess()


    // Entrata: sale + fade + scala con bounce
    Animated.parallel([
      Animated.spring(translateY, { toValue: 0, useNativeDriver: true, tension: 80, friction: 6 }),
      Animated.spring(scale, { toValue: 1, useNativeDriver: true, tension: 80, friction: 6 }),
      Animated.timing(opacity, { toValue: 1, duration: 200, useNativeDriver: true }),
    ]).start()

    // Uscita dopo 2.5s
    const timer = setTimeout(() => {
      Animated.parallel([
        Animated.timing(translateY, { toValue: 120, duration: 300, useNativeDriver: true }),
        Animated.timing(scale, { toValue: 0.9, duration: 300, useNativeDriver: true }),
        Animated.timing(opacity, { toValue: 0, duration: 300, useNativeDriver: true }),
      ]).start(() => {
        if (isMounted.current) onDoneRef.current?.()
      })
    }, 2500)

    return () => {
      isMounted.current = false
      clearTimeout(timer)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Animated.View style={[styles.container, { transform: [{ translateY }, { scale }], opacity }]}>
      <View style={styles.toast}>
        <View style={styles.iconWrap}>
          <MaterialCommunityIcons name="check-circle" size={20} color={tc.brandText} />
        </View>
        <View style={{ flex: 1, minWidth: 0 }}>
          <Text style={styles.title}>
            {leagueCount > 1
              ? t('pick.toast_multi', { count: leagueCount })
              : t('pick.toast_single')
            }
          </Text>
          <Text style={styles.subtitle} numberOfLines={1}>
            {riders.map(r => r.label.split('] ').pop()).join(' · ')}
          </Text>
        </View>
      </View>
    </Animated.View>
  )
}

const makeStyles = (tc) => StyleSheet.create({
  container: {
    position: 'absolute', bottom: 90, left: 16, right: 16, zIndex: 9999,
  },
  toast: {
    flexDirection: 'row', alignItems: 'center', gap: 14,
    backgroundColor: tc.rosa,
    borderRadius: radius.xl, padding: 14, paddingHorizontal: 18,
  },
  iconWrap: {
    width: 40, height: 40, borderRadius: 20,
    backgroundColor: colors.white20,
    alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  },
  title: { fontFamily: fonts.condensedBold, fontSize: 15, color: tc.brandText, letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 3 },
  subtitle: { fontSize: 12, color: colors.white85 },
})